export enum EApiContentType {
  ApplicationJson = 0,
  FormUrlEncoded = 1,
  ApplicationXml = 2
}
